import React from 'react';
import SmallTitle from '../../../../components/SmallTitle';
import { Row } from 'reactstrap';
import { Link } from './style';

export const SitemapSubItem = props => {
  const {
    data: { title, url, parameters },
  } = props;
  
  const target = parameters ? parameters.split('target="').pop().split('"')[0] : '_self';

  return (
    <Row className="mx-0">
      {url ? (
          <>
            <Link href={url} target={target} className="skip-nav-focus">
              <u>{title}</u>
            </Link>
          </>
      ) : (
          <>
            <SmallTitle className="mt-sm-1">{title}</SmallTitle>
          </>
      )}
    </Row>
  );
};
